import {
  GET_EVENTS_REQUEST,
  GET_EVENTS_SUCCESS,
  GET_EVENTS_FAILURE,
  SEND_EVENT_REQUEST,
  SEND_EVENT_SUCCESS,
  SEND_EVENT_FAILURE,
  EventsActionTypes,
  EventsState,
} from './events.types';

const initialState: EventsState = {
  events: [],
  loading: false,
  error: null,
  sendEventLoading: false,
  sendEventError: null,
};

const eventsReducer = (
  state: EventsState = initialState,
  action: EventsActionTypes
): EventsState => {
  switch (action.type) {
    case GET_EVENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_EVENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        events: action.payload,
        error: null,
      };
    case GET_EVENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SEND_EVENT_REQUEST:
      return {
        ...state,
        sendEventLoading: true,
        sendEventError: null,
      };
    case SEND_EVENT_SUCCESS:
      return {
        ...state,
        sendEventLoading: false,
        sendEventError: null,
      };
    case SEND_EVENT_FAILURE:
      return {
        ...state,
        sendEventLoading: false,
        sendEventError: action.payload,
      };
    default:
      return state;
  }
};

export default eventsReducer;
